import './../template/template.js'
import './style.min.css'

const isFR = document.documentElement.lang == 'fr'
let gsapData = null

if (isFR) {
    try {
        gsapData = await import('./../../fr/node_modules/gsap')
    } catch (error) {
        console.log(error)
    }
} else {
    try {
        gsapData = await import('./../../en/node_modules/gsap')
    } catch (error) {
        console.log(error)
    }
}
const gsap = gsapData.default

let scrollTriggerData = null
if (isFR) {
    try {
        scrollTriggerData = await import('./../../fr/node_modules/gsap/ScrollTrigger.js')
    } catch (error) {
        console.log(error)
    }
} else {
    try {
        scrollTriggerData = await import('./../../en/node_modules/gsap/ScrollTrigger.js')
    } catch (error) {
        console.log(error)
    }
}
const ScrollTrigger = scrollTriggerData.default

// Initialize ScrollTrigger
gsap.registerPlugin(ScrollTrigger)
ScrollTrigger.defaults({
    invalidateOnRefresh: true,
    scrub: 0.1,
})

const backgrounds = document.querySelectorAll('.person .background')

// Scale down background
backgrounds.forEach((e) => {
    gsap.fromTo(
        e,
        {
            // height: '55vh',
            height: '9em',
        },
        {
            // height: '20vh',
            height: '3.5em',
            ease: 'linear',
            scrollTrigger: {
                trigger: e,
                start: '0% bottom',
                end: '100% top',
                // pin: '.huge-title',
                // anticipatePin: 1,
                // markers: true,
            },
        }
    )
})
